import React from 'react';
import { Grid } from '@mui/material';
import { NetworkMap, NetworkTrafficTable, NetworkOverviewTable, transformNetworkOverviewData } from '@kw/quokka-ui';

export const NewNetworkInfoTab = ({
  geolocationsData,
  trafficData,
  sslPinningData,
  staticUrisData,
  highRiskCountries,
  downloadPcapCallback,
}) => (
  <Grid container direction="column" spacing={5}>
    <Grid item xs={12}>
      <NetworkMap geolocations={geolocationsData} mapTilerApiKey={process.env.REACT_APP_MAPTILER_API_KEY} />
    </Grid>
    <Grid item xs={12}>
      <NetworkOverviewTable
        traffic={transformNetworkOverviewData({ sslPinning: sslPinningData, staticUrls: staticUrisData, geolocations: geolocationsData })}
        highRiskCountries={highRiskCountries}
      />
    </Grid>
    <Grid item xs={12}>
      <NetworkTrafficTable traffic={trafficData} downloadPcapCallback={downloadPcapCallback} />
    </Grid>
  </Grid>
);
